import * as actions from './scheduleReportsTypes';

const initialState = {
    // List of scheduled reports
    scheduledReportsList: [],

    // Pagination data
    pagination: {
        page: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0
    },

    // Current schedule details
    scheduleDetails: null,

    // Execution logs for a schedule
    executionLogs: [],

    // Available reports for scheduling
    availableReports: [],

    // Published reports for scheduling
    publishedReports: [],
    publishedReportsLoading: false,

    // Loading states
    loading: false,
    saving: false,
    updating: false,
    deleting: false,
    scheduleDetailLoading: false,

    // Error handling
    error: null,

    // Last created/updated schedule
    lastSchedule: null
};

const scheduleReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Set scheduled reports list
        case actions.SET_SCHEDULED_REPORTS_LIST:
            return {
                ...state,
                scheduledReportsList: action.payload.list || [],
                loading: false,
                error: null
            };

        // Set pagination data
        case actions.SET_SCHEDULES_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload.pagination
                }
            };

        // Schedule created successfully
        case actions.SET_SCHEDULE_CREATED:
            return {
                ...state,
                lastSchedule: action.payload.schedule,
                saving: false,
                error: null,
                // Optionally add to list if returned with full data
                scheduledReportsList: action.payload.schedule
                    ? [...state.scheduledReportsList, action.payload.schedule]
                    : state.scheduledReportsList
            };

        // Set saving state
        case actions.SET_SCHEDULE_SAVING:
            return {
                ...state,
                saving: action.payload.saving
            };

        // Schedule updated successfully
        case actions.SET_SCHEDULE_UPDATED:
            return {
                ...state,
                lastSchedule: action.payload.schedule,
                updating: false,
                error: null,
                // Update in the list if scheduleId matches
                scheduledReportsList: state.scheduledReportsList.map(schedule =>
                    schedule.scheduleId === action.payload.schedule?.scheduleId
                        ? { ...schedule, ...action.payload.schedule }
                        : schedule
                )
            };

        // Set updating state
        case actions.SET_SCHEDULE_UPDATING:
            return {
                ...state,
                updating: action.payload.updating
            };

        // Schedule deleted successfully
        case actions.SET_SCHEDULE_DELETED:
            return {
                ...state,
                deleting: false,
                error: null,
                // Remove from list
                scheduledReportsList: state.scheduledReportsList.filter(
                    schedule => schedule.scheduleId !== action.payload.scheduleId
                )
            };

        // Set deleting state
        case actions.SET_SCHEDULE_DELETING:
            return {
                ...state,
                deleting: action.payload.deleting
            };

        // Schedule status updated (Active/Paused)
        case actions.SET_SCHEDULE_STATUS_UPDATED:
            return {
                ...state,
                error: null,
                scheduledReportsList: state.scheduledReportsList.map(schedule =>
                    schedule.scheduleId === action.payload.scheduleId
                        ? { ...schedule, status: action.payload.status }
                        : schedule
                )
            };

        // Set schedule details
        case actions.SET_SCHEDULE_DETAILS:
            return {
                ...state,
                scheduleDetails: action.payload.schedule,
                scheduleDetailLoading: false,
                error: null
            };

        // Set execution logs
        case actions.SET_SCHEDULE_EXECUTION_LOGS:
            return {
                ...state,
                executionLogs: action.payload.logs || [],
                error: null
            };

        // Set loading states
        case actions.SET_SCHEDULES_LOADING:
            return {
                ...state,
                loading: action.payload.loading
            };

        case actions.SET_SCHEDULE_DETAIL_LOADING:
            return {
                ...state,
                scheduleDetailLoading: action.payload.loading
            };

        // Set available reports for scheduling
        case actions.SET_AVAILABLE_REPORTS_FOR_SCHEDULE:
            return {
                ...state,
                availableReports: action.payload.reports || [],
                error: null
            };

        // Set published reports for scheduling
        case actions.SET_PUBLISHED_REPORTS_LIST:
            return {
                ...state,
                publishedReports: action.payload.reports || [],
                publishedReportsLoading: false,
                error: null
            };

        case actions.SET_PUBLISHED_REPORTS_LOADING:
            return {
                ...state,
                publishedReportsLoading: action.payload.loading
            };

        // Error handling
        case actions.SET_SCHEDULES_ERROR:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
                saving: false,
                updating: false,
                deleting: false,
                scheduleDetailLoading: false
            };

        case actions.CLEAR_SCHEDULES_ERROR:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

export default scheduleReportsReducer;
